import homeVideoCat from '@assets/images/home-video-cat.webp';
import { Advantages } from '@pages/home/cats/Advantages';
import { TextBox } from '@pages/home/cats/TextBox';



export const CollarContent = () => {

	return (
		<div className='collar-content'>

			<Advantages />

			<div className='video-placeholder-image'>
				<img src={homeVideoCat} alt='video-placeholder-photo' />
			</div>
			
			<TextBox />

		</div>
	);
};